// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hlWW","textarea":"styles_textarea__2SBDi"};